import * as THREE from 'three';

export default class LODManager {
    constructor(scene, cameraControls, resources, world) {
        // this.experience = experience;
        this.scene = scene;
        this.cameraControls = cameraControls;
        this.resources = resources;
        this.world = world;
        this.highInstancedMesh = null;
        this.treeHighInstancedMesh = null;
        this.poplarHighInstancedMesh = null;
        this.targets = []; // List of all LOD-enabled objects
    }

    register({
        name,
        type = 'geometry',
        object = null,
        lowTex = null,
        highTex = null,
        lowObject,
        lowInstances,
        highUrl,
        position,
        threshold = 5,
        onLoadHigh = () => { },
    }) {
        this.targets.push({
            name,
            type,
            state: "low" | "loading" | "high",
            object,
            lowTex,
            highTex,
            lowObject,
            lowInstances,
            highUrl,
            highObject: null,
            highTexture: null,
            position,
            threshold,
            loaded: false,
            loading: false,
            onLoadHigh,
        });
    }

    mulberry32(seed) {
        let t = seed + 0x6D2B79F5;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    }

    async update() {
        const camPos = new THREE.Vector3();
        cameraControls.getPosition(camPos);

        for (const target of this.targets) {
            if (target.type === 'texture') {
                // console.log(target.object.scene.children[0])

                const distance = camPos.distanceTo(target.position);

                if (distance < target.threshold) {
                    if (target.state !== "high") {
                        if (target.state === "high" || target.loading) {
                            // Already loaded or currently loading — skip
                            return;
                        }
                        target.loading = true;

                        const loadingManager = new THREE.LoadingManager();

                        if (!target.highTexture) {
                            // Load high texture
                            const loader = new THREE.TextureLoader(loadingManager);
                            // loadingManager.onLoad = function (item, loaded, total) {

                            //     //Loading percentage
                            //     console.log('loaded');

                            // }

                            loader.load(target.highTex, (texture) => {
                                // Need to flip texture
                                texture.wrapS = THREE.RepeatWrapping;
                                texture.wrapT = THREE.RepeatWrapping;
                                texture.repeat.y = -1;
                                texture.colorSpace = THREE.SRGBColorSpace;
                                target.highTexture = texture;
                                target.object.scene.children[0].traverse((child) => {
                                    if (child.isMesh) {
                                        child.material.map = texture;
                                        child.material.needsUpdate = true;
                                    }
                                });
                                // Texture downloads immediately, not yet visible. Need a couple of frames delay for the texture to load visibly, doesn't always work but no other way.
                                requestAnimationFrame(() => {
                                    requestAnimationFrame(() => {
                                        // Now the texture should be rendered
                                        // document.getElementById('loading-screen').classList.add('done-transitioning')
                                        // document.getElementById('loading-screen').classList.remove('transitioning')

                                        target.state = "high";
                                        target.loading = false;
                                        // console.log("high loaded")
                                        document.getElementById('loading-screen').classList.remove('transitioning')
                                        document.getElementById('loading-screen').classList.remove('loading-textures')
                                        document.getElementById('loading-screen').classList.add('loaded-textures')

                                    });
                                });
                            }
                            );
                        } else {
                            // Already loaded
                            target.object.scene.children[0].traverse((child) => {
                                if (child.isMesh) {
                                    child.material.map = target.highTexture;
                                    child.material.needsUpdate = true;
                                }
                            });
                            target.state = "high";
                            target.loading = false;
                        }

                    }
                } else {
                    if (target.state === "low" || target.lowLoading) {
                        // Already loaded or currently loading — skip
                        return;
                    }
                    target.lowLoading = true;
                    // Need this so it switches back to low quality when zooming out
                    if (target.state !== "low") {
                        const loader = new THREE.TextureLoader();
                        loader.load(target.lowTex, (texture) => {
                            // Need to flip texture
                            texture.wrapS = THREE.RepeatWrapping;
                            texture.wrapT = THREE.RepeatWrapping;
                            texture.repeat.y = -1;
                            texture.colorSpace = THREE.SRGBColorSpace;

                            target.object.scene.children[0].traverse((child) => {
                                if (child.isMesh) {
                                    child.material.map = texture;
                                    child.material.needsUpdate = true;
                                }
                            });
                            // Texture downloads immediately, not yet visible. Need a couple of frames delay for the texture to load visibly
                            requestAnimationFrame(() => {
                                requestAnimationFrame(() => {
                                    // Now the texture should be rendered
                                    // document.getElementById('loading-screen').classList.add('done-loading')
                                    // document.getElementById('loading-screen').classList.remove('transitioning')

                                    target.state = "low";
                                    target.loading = false;

                                    document.getElementById('loading-screen').classList.remove('loading-textures')
                                    // document.getElementById('loading-screen').classList.remove('loaded-textures')

                                    // document.getElementById('loading-screen').classList.remove('transitioning')
                                });
                            });
                        });
                    }
                }
                // }
            }

            else {

                const distance = camPos.distanceTo(target.position);
                let offset = 0
                if (target.name == "treeHigh") { offset = 2 } else { offset = 0; }

                if (distance < target.threshold) {
                    if (!target.loaded && !target.loading) {
                        target.loading = true;
                        target.state = "loading"
                        // const gltf = this.resources.lazyLoadGLTF(target.name, target.highUrl);
                        const gltf = await this.resources.lazyLoadGLTF(target.name, target.highUrl);

                        if (target.name == "treeHigh") {
                            target.highObject = gltf.scene.children[0];
                        }

                        if (target.name == "poplarHigh") {
                            target.highObject = gltf.scene.children[0];
                        }

                        // Common settings
                        let scale
                        if (target.name == "treeHigh") {
                            scale = new THREE.Vector3(0.14, 0.14, 0.14); // Get it from the Tree class.
                        }
                        if (target.name == "poplarHigh") {
                            scale = new THREE.Vector3(0.25, 0.25, 0.25); // Get it from the Tree class.
                        }
                        const xRotation = 0;

                        // Foliage
                        if (target.name == "treeHigh") {
                            this.treeHighFoliageMesh = target.highObject; // Extra children[0] because the tree has two meshes for each material
                            this.treeFoliageGeometry = this.treeHighFoliageMesh.geometry.clone(); // Clone it
                            this.treeFoliageGeometry.applyMatrix4(this.treeHighFoliageMesh.matrixWorld);

                            this.treeFoliageMaterial = new THREE.MeshStandardMaterial({ map: this.world.floor.model.children[9].material.map })
                        }
                        if (target.name == "poplarHigh") {
                            this.poplarHighFoliageMesh = target.highObject; // Extra children[0] because the tree has two meshes for each material
                            this.poplarFoliageGeometry = this.poplarHighFoliageMesh.geometry.clone(); // Clone it
                            this.poplarFoliageGeometry.applyMatrix4(this.poplarHighFoliageMesh.matrixWorld);

                            this.poplarFoliageMaterial = new THREE.MeshStandardMaterial({ map: this.world.floor.model.children[9].material.map })
                        }

                        // Create InstancedMesh
                        if (target.name == "treeHigh") {
                            this.treeHighFoliageInstancedMesh = new THREE.InstancedMesh(
                                this.treeFoliageGeometry,
                                this.treeFoliageMaterial,
                                this.world.tree.markers.length
                            )
                        };
                        if (target.name == "poplarHigh") {
                            this.poplarHighFoliageInstancedMesh = new THREE.InstancedMesh(
                                this.poplarFoliageGeometry,
                                this.poplarFoliageMaterial,
                                this.world.poplar.markers.length
                            )
                        };

                        // Set transform for each instance
                        // Tree
                        if (target.name == "treeHigh") {
                            for (let i = 0; i < this.world.tree.markers.length; i++) {
                                const child = this.world.tree.markers[i];
                                const yRandom = this.mulberry32(i + 1) * Math.PI * 2; // full rotation 0-360°
                                const euler = new THREE.Euler(
                                    xRotation,  // your existing X rotation in radians
                                    yRandom,
                                    0,
                                    'YXZ' // Rotate Y first
                                );

                                const quaternion = new THREE.Quaternion().setFromEuler(euler);

                                const matrix = new THREE.Matrix4();
                                matrix.compose(
                                    child.position.clone(),
                                    quaternion.clone(),
                                    scale.clone().add(new THREE.Vector3(yRandom / 200, yRandom / 200, yRandom / 200))
                                );

                                this.treeHighFoliageInstancedMesh.setMatrixAt(i, matrix);
                            }
                        }

                        if (target.name == "poplarHigh") {
                            // Poplar
                            for (let i = 0; i < this.world.poplar.markers.length; i++) {
                                const child = this.world.poplar.markers[i];
                                const yRandom = this.mulberry32(i + 1) * Math.PI * 2; // full rotation 0-360°
                                const euler = new THREE.Euler(
                                    xRotation,  // your existing X rotation in radians
                                    yRandom,
                                    0,
                                    'YXZ' // Rotate Y first
                                );

                                const quaternion = new THREE.Quaternion().setFromEuler(euler);

                                const matrix = new THREE.Matrix4();
                                matrix.compose(
                                    child.position.clone(),
                                    quaternion.clone(),
                                    scale.clone().add(new THREE.Vector3(yRandom / 200, yRandom / 200, yRandom / 200))
                                );

                                this.poplarHighFoliageInstancedMesh.setMatrixAt(i, matrix);
                            }
                        }

                        if (target.name == "treeHigh") {
                            this.treeHighFoliageInstancedMesh.instanceMatrix.needsUpdate = true;
                            this.treeHighFoliageInstancedMesh.castShadow = true;
                            this.treeHighFoliageInstancedMesh.receiveShadow = true;
                            this.scene.add(this.treeHighFoliageInstancedMesh);
                        }
                        if (target.name == "poplarHigh") {
                            this.poplarHighFoliageInstancedMesh.instanceMatrix.needsUpdate = true;
                            this.poplarHighFoliageInstancedMesh.castShadow = true;
                            this.poplarHighFoliageInstancedMesh.receiveShadow = true;
                            this.scene.add(this.poplarHighFoliageInstancedMesh);

                        }

                        target.loaded = true;

                    } else if (target.loaded) {
                        target.state = "high"
                    }
                } else {
                    target.state = "low"
                }

                // console.log(this.world.poplar.foliageInstancedMesh.visible) // true/false check
                // console.log(this.world.poplar.trunkInstancedMesh.visible) // true/false check
                // console.log(target.highObject) // Null TODO: Fix this.
                // console.log(target.state, target.lowObject, target.lowInstances) // All exist

                if (target.state === "low") {
                    if (target.lowObject) { target.lowObject.visible = true } // Works
                    if (target.lowInstances.visible) { target.lowInstances.visible = true } else {
                        if (target.name == "treeHigh") {
                            if (this.treeHighFoliageInstancedMesh) this.treeHighFoliageInstancedMesh.visible = false;
                            // this.world.tree.trunkInstancedMesh.visible = true;
                            if (this.world.tree.foliageInstancedMesh) this.world.tree.foliageInstancedMesh.visible = true;
                        }
                        if (target.name == "poplarHigh") {
                            if (this.poplarHighFoliageInstancedMesh) this.poplarHighFoliageInstancedMesh.visible = false;
                            // this.world.poplar.trunkInstancedMesh.visible = true;
                            if (this.world.poplar.foliageInstancedMesh) this.world.poplar.foliageInstancedMesh.visible = true;
                        }
                    }// Works
                    if (target.highObject) { target.highObject.visible = false }
                    if (target.name == "treeHigh") {
                        if (target.treeHighFoliageInstancedMesh) { target.treeHighFoliageInstancedMesh.visible = false }
                    }
                    if (target.name == "poplarHigh") {
                        if (target.poplarFoliageHighInstancedMesh) { target.poplarFoliageHighInstancedMesh.visible = false }
                    }
                } else if (target.state === "loading") {
                    if (target.lowObject) { target.lowObject.visible = true } // Works
                    if (target.lowInstances.visible) { target.lowInstances.visible = true } else {
                        // this.world.tree.trunkInstancedMesh.visible = true;
                        this.world.tree.foliageInstancedMesh.visible = true;
                        // this.world.poplar.trunkInstancedMesh.visible = true;
                        this.world.poplar.foliageInstancedMesh.visible = true
                    } // Works
                    // if (target.highObject) { target.highObject.visible = false }
                    // if (target.highInstancedMesh) { target.highInstancedMesh.visible = false }
                    document.getElementById('loading-screen').classList.add('loading-textures')
                } else if (target.state === "high") {
                    if (target.lowObject) { target.lowObject.visible = false } // Not sure what it does
                    if (target.lowInstances.visible) { target.lowInstances.visible = false } else {
                        if (target.state === "high") {
                            if (target.name === "treeHigh") {
                                this.treeHighFoliageInstancedMesh.visible = true;
                                // this.world.tree.trunkInstancedMesh.visible = false;
                                this.world.tree.foliageInstancedMesh.visible = false;
                            }
                            if (target.name === "poplarHigh") {
                                this.poplarHighFoliageInstancedMesh.visible = true;
                                // this.world.poplar.trunkInstancedMesh.visible = false;
                                this.world.poplar.foliageInstancedMesh.visible = false;
                            }
                        }

                    } // Works
                    // if (target.highObject) { target.highObject.visible = true }
                    // if (target.highInstancedMesh) { target.highInstancedMesh.visible = true }
                    document.getElementById('loading-screen').classList.remove('loading-textures')
                }
            }
        }
    }
}
